// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "organization_photo".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "organization_photo" table (1:1 with a DB row, on the wire). */
export const organizationPhotoAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    locationId: z.string().nullable(),
    url: z.string(),
    caption: z.string().nullable(),
    sortOrder: z.number(),
    isCover: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=organizationPhoto.js.map